export default __webpack_public_path__ + "static/chaos-warriors-fffcff98be3ffa983ff26780074cc5ab.webp";